import { styled } from '@clickcease/cc-client-components-lib'

export const AddDomainStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const InputError = styled('div', {
  color: '$error',
  fontWeight: '$l',
  fontSize: '$sm',
  position: 'absolute',
  bottom: '-15px',
  left: '0px',
})

export const DomainModalError = styled('div', {
  color: '$error',
  fontWeight: '$l',
  fontSize: '$sm',
  marginTop: '10px',
})

export const AddDomainModalInput = styled('div', {
  width: '100%',
  marginBlock: '$8',
  position: 'relative',
})

export const AddDomainModalButtonContainer = styled('div', {
  width: '100%',
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
})

export const ToastPadding = styled('div', {
  marginBottom: '$6',
  marginTop: '$2',
})
